var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDownSmall = function SvgChevronDownSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 14.9998L7.75684 10.7568L9.17184 9.34277L11.9998 12.1718L14.8278 9.34277L16.2428 10.7568L11.9998 14.9998Z",
    fill: "currentColor"
  })));
};
export default SvgChevronDownSmall;